import Column from '@components/Column';
import Divider from '@components/Divider';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { EventResponse } from '@models/event';
import dayjs from 'dayjs';

interface Props {
    event: EventResponse;
}

function EventHeader({ event }:Props) {
    const { title, startAt, endAt } = event;
    const eventDuration = `${dayjs(startAt).format('YYYY.MM.DD')} - ${dayjs(endAt).format('YYYY.MM.DD')}`;
    return (
        <Container as='section'
            fullWidth
            spacing={16}>
            <Title size='2xl' fontWeight='bold' >{title}</Title>
            <Text color={colors.gray6}>{eventDuration}</Text>
            <Divider isThin />
        </Container>
    );
}

const Container = styled(Column)`
    padding: 28px 20px 16px;
`;

const Title = styled(Text)`
    white-space: wrap;
    word-break: break-word;
    width: 100%;
`;

export default EventHeader;
